import React, { useEffect, useState } from "react";
import { oauth2 as SMART } from "fhirclient";
import FHIRContext, { FHIRContextType } from "./index";
import {
  LaunchStage,
  logLaunchError,
  logLaunchEvent,
} from "../../utils/telemetry";
interface FHIRContextProviderProps {
  children: React.ReactNode;
}

const FHIRContextProvider: React.FC<FHIRContextProviderProps> = ({
  children,
}) => {
  const [client, setClient] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    logLaunchEvent(LaunchStage.TOKEN_EXCHANGE, "Starting SMART.ready()");
    SMART.ready()
      .then(
        (client) => {
          logLaunchEvent(LaunchStage.TOKEN_EXCHANGE, "SMART.ready() resolved", {
            fhir_server_url: client?.state?.serverUrl,
          });
          setClient(client);
        },
        (error) => {
          logLaunchError(LaunchStage.TOKEN_EXCHANGE, error, {
            failure: "smart_ready_rejected",
          });
          setError(error instanceof Error ? error.message : String(error));
        }
      )
      .finally(() => setIsLoading(false));
  }, []);

  const value: FHIRContextType = {
    client,
    isLoading,
    error,
  };

  return <FHIRContext.Provider value={value}>{children}</FHIRContext.Provider>;
};

export default FHIRContextProvider;
